import { render, staticRenderFns } from "./ClockWidget.vue?vue&type=template&id=713a9508&scoped=true"
import script from "./ClockWidget.vue?vue&type=script&lang=js"
export * from "./ClockWidget.vue?vue&type=script&lang=js"
import style0 from "./ClockWidget.vue?vue&type=style&index=0&id=713a9508&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a9508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713a9508')) {
      api.createRecord('713a9508', component.options)
    } else {
      api.reload('713a9508', component.options)
    }
    module.hot.accept("./ClockWidget.vue?vue&type=template&id=713a9508&scoped=true", function () {
      api.rerender('713a9508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/ClockWidget.vue"
export default component.exports